"use client";

import React from "react";
import { ArrowRight, Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsFindYourVoice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="lets-find-your-voice" className="dark bg-background text-foreground py-24 px-4 md:py-32 relative overflow-hidden flex flex-col items-center justify-center min-h-[50vh]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(220_25%_15%)_0%,transparent_70%)] opacity-40 pointer-events-none" />

      <div ref={ref} className={`relative z-10 w-full max-w-2xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-12 text-white">
          Ready to be understood?
        </h2>

        <div className="w-full max-w-md mx-auto">
          <FormProvider formId="newsletter-signup-footer" sectionName="lets-find-your-voice" defaultValues={{
          email: ""
        }} validationRules={{
          email: {
            required: true,
            pattern: "email"
          }
        }} submitText="Subscribe" successMessage="You're on the list. Let's find your voice.">
            <NewsletterForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    control,
    handleSubmit,
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary/10 border border-primary/20 rounded-lg animate-in fade-in zoom-in duration-500">
        <p className="text-primary text-lg font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full space-y-6">
      <div className="relative flex items-end gap-4">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1 space-y-0">
              <FormControl>
                <Input placeholder="Enter your email address" {...field} className="border-x-0 border-t-0 border-b-2 border-muted-foreground/30 bg-transparent rounded-none px-0 py-6 text-xl md:text-2xl placeholder:text-muted-foreground/50 focus-visible:ring-0 focus-visible:border-primary transition-colors duration-300 shadow-none" />
              </FormControl>
              <FormMessage className="absolute -bottom-6 left-0 text-xs" />
            </FormItem>} />

        <Button type="submit" disabled={isSubmitting} size="icon" variant="ghost" className="mb-2 size-12 rounded-full text-primary hover:text-primary hover:bg-primary/10 hover:shadow-[0_0_20px_hsl(174_35%_55%_/_0.4)] transition-all duration-300" aria-label="Submit email">
          {isSubmitting ? <Loader className="size-6 animate-spin" /> : <ArrowRight className="size-8" />}
        </Button>
      </div>

      {submitError && <p className="text-destructive text-sm mt-2">{submitError}</p>}
    </Form>;
}